;(function ( $, window, document, undefined ){

	//isMobile 判斷
	var isMobile = false;
	if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ){
		isMobile = true
	}

	// Browser 判斷
	var ua = navigator.userAgent;
	var browser = {
		isChrome: /chrome/i.test(ua),
		isFirefox: /firefox/i.test(ua),
		isSafari: /safari/i.test(ua),

		// https://msdn.microsoft.com/en-us/library/ms537503(v=vs.85).aspx
		isIE: /msie/i.test(ua) || /trident/i.test(ua),
		isEdge: /edge/i.test(ua)
	};

	// 修正browser.Safari數值
	browser.isSafari = (browser.isChrome||browser.isFirefox||browser.isIE||browser.isEdge) ? false : true;


	var iframe = $('#iframe');
	var iframeOffsetTop;
	var headerHeight;
	var scrollTarget = (browser.isSafari) ? $('body') : $('html');

	var resizeInfo = function(){
		iframeOffsetTop = Math.round(iframe.offset().top);
		headerHeight = $('header').innerHeight();
	}
	resizeInfo();

	//判斷Resize
	var isResize = false;
	var resizeValueReturn = function(){
		isResize = true;
		setTimeout(function(){
			isResize = false;
		},500)
	}


	//------------------------------------------------- 更改高

	// 紀錄傳回的舊值
	var oldData = null;

	// 確認是否是第一次進入頁面
	var isFirstTime = true;

	var changeHeightHandler = function(data){
		if(oldData != data){
			//更新Data
			oldData = data;

			//重置捲軸高度(高度需照外版調整故先預設0)

			if(isFirstTime){
				// 是第一次進入此頁
				isFirstTime = false;
			}else{
				// 不是第一次進入此頁
				// 不是Resize才調整ScrollTop

				if(!isResize){

					var needScroll = function(){
						// 修正值
						// Safari因為是body, 所以撐到20
						var edit = (browser.isSafari) ? 30 : 10;

						if(scrollTarget.scrollTop() + 80 > iframeOffsetTop + edit){
							return true
						}else if(scrollTarget.scrollTop() + 80 >= iframeOffsetTop - edit){
							return false
						}else{
							return true
						}
					}

					if(needScroll){
						if(scrollTarget.scrollTop() > iframeOffsetTop){
							scrollTarget.scrollTop(iframe.offset().top - headerHeight);
						}else{
							scrollTarget.animate({scrollTop: iframe.offset().top - headerHeight},500);
						}
					}

					// if(needScroll()){
					// 	scrollTarget.animate({scrollTop: iframe.offset().top - headerHeight},500);
					// 	iframe.addClass('transition-delay');
					// 	setTimeout(function(){
					// 		iframe.removeClass('transition-delay');
					// 	},500);
					// }
				}
			}

			iframe.css('height', data + 'px');
		}
		// console.log('height: ',data)
	}


	//------------------------------------------------- 更改滑動
	// var changeScrollHandler = function(data){
	// 	if(!browser.isSafari && $("html").getNiceScroll(0)){
	// 		$("html").getNiceScroll(0).doScrollTop(scrollTarget.scrollTop()-data*2);
	// 	}
	// }


	//------------------------------------------------- 監聽傳值事件(Message)

	var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
	var eventer = window[eventMethod];
	var messageEvent = eventMethod == 'attachEvent' ? 'onmessage' : 'message';

	eventer(messageEvent, function (e) {
		if (e.origin !== 'https://service.sakura.com.tw') return;

		// console.log(e.data)

		var key = e.message ? "message" : "data";
		var data = e[key];

		//如果ResponseContentHeight.js舊檔案
		changeHeightHandler(data)

		//新檔案
		// switch(data.type){
		// 	case 'height': 
		// 		changeHeightHandler(data.height)
		// 		break;
		// 	case 'scroll': 
		// 		changeScrollHandler(data.scrollY)
		// 		break;
		// }

	}, false);



	// 讀取iframe
	// Reference https://stackoverflow.com/a/32791713
	function iframeRender() {
		var site = "https://service.sakura.com.tw/";
		var iframe = document.getElementsByName('iframe')[0];
		iframe.style.width = '100%';
		// iframe.style.height = '1200px';
		iframe.style.overflow = 'hidden';

		iframe.src = site;
		// iframe.onload = iframeOnload(iframe);
	}
	iframeRender();


	function onResizeEventHandler(ev){
		resizeValueReturn();
		resizeInfo();
	}

	var el = window;

	if(el.addEventListener){
		el.addEventListener('resize', onResizeEventHandler, false);   
	} else if (el.attachEvent){
		el.attachEvent('onresize', onScrollEventHandler); 
	}

	// NiceScroll 於 iframe 有Bug
	// 如果ResponseContentHeight.js舊檔案
	// 即停止NiceScroll
	// window.onload = function(){
	// 	$("html").getNiceScroll().remove();
	// }

})(jQuery, window, document);
